import React, { useState, useRef, useEffect } from "react";
import "./aboutus.css";

const AboutUs = () => {
  const [selectedContent, setSelectedContent] = useState(null);
  const popupRef = useRef();

  const sections = [
    {
      title: "ശാഖകൾ",
      content: `ബാലജനസഖ്യത്തിലെ പ്രാഥമികഘടകമായ ശാഖ രൂപീകരിക്കുന്നതിന് കുറഞ്ഞത് 15 അംഗങ്ങളും അവർക്കു നേതൃത്വം നൽകുവാൻ 18 വയസ്സിൽ കൂടുതലുള്ള സഹകാരിയും ഉണ്ടായിരിക്കണം.
  ഏതെങ്കിലും രാഷ്‌ട്രീയ പാർട്ടിയുടെ ഔദ്യോഗിക ഭാരവാഹിയോ സജീവ പ്രവർത്തകനോ സഹകാരിയാകാൻ പാടില്ല.
  ആറുമുതൽ 18 വയസ്സുവരെയുള്ള ആർക്കും സഖ്യത്തിൽ അംഗമാകാം.
  ഓരോ ശായ്‌ക്കും പ്രസിഡന്റ്, വൈസ് പ്രസിഡന്റ്, സെക്രട്ടറി, ജോയിന്റ് സെക്രട്ടറി, ട്രഷറർ, യൂണിയൻ പ്രതിനിധി, സേവനവിഭാഗം കൺവീനർ, ബാലികാവിഭാഗം കൺവീനർ എന്നിവർ ഉൾപ്പെട്ട പ്രവർത്തകസമിതി ഉണ്ടായിരിക്കണം.
  ഭാരവാഹികളെ ഓരോ വർഷത്തേക്കും സഖ്യാംഗങ്ങൾ തിരഞ്ഞെടുക്കും.
  ഓരോ ശാഖയും അതത് പ്രദേശത്തെ യുണിയന്റെ ഘടകം ആയിരിക്കും.`,
    },
    {
      title: "യൂണിയനുകൾ",
      content: `പത്തോ അതിലധികമോ ശാഖകൾ ഉള്ള പ്രദേശങ്ങൾ കേന്ദ്രമാക്കി ശങ്കരച്ചേട്ടൻ യൂണിയൻ അനുവദിക്കും.
  യൂണിയനു നേതൃത്വം നൽകുന്ന രക്ഷാധികാരിയെ ശങ്കരച്ചേട്ടൻ നാമനിർദേശം ചെയ്യും.
  ശാഖകളുടെ പ്രസിഡന്റ്, സെക്രട്ടറി, യൂണിയൻ പ്രതിനിധി എന്നിവർ ഉൾപ്പെട്ട യൂണിയൻ സഭയിൽനിന്നാണ് യൂണിയൻ ഭാരവാഹികളെ തിരഞ്ഞെടുക്കുക.
  പ്രസിഡന്റ്, വൈസ് പ്രസിഡന്റ്, സെക്രട്ടറി, ജോയിന്റ് സെക്രട്ടറി, ട്രഷറർ, മേഖലാസഭാംഗം, സേവനവിഭാഗം കൺവീനർ, ബാലികാവിഭാഗം കൺവീനർ എന്നിവരാണ് യൂണിയൻ ഭാരവാഹികൾ.`,
    },
    {
      title: "മേഖലകൾ",
      content: `14 ജില്ലകളിലായി അഖില കേരള ബാലജനസഖ്യത്തിന് ഇപ്പോൾ 11 മേഖലകളാണുള്ളത്.
  യൂണിയനുകളിലെ മേഖലാസഭാംഗങ്ങൾ ഉൾപ്പെട്ട മേഖലാസഭയിൽനിന്നാണ് ഭാരവാഹികളെ തിരഞ്ഞെടുക്കുക.
  പ്രസിഡന്റ്,VICE പ്രസിഡന്റ്, സെക്രട്ടറി, ജോയിന്റ് സെക്രട്ടറി, ട്രഷറർ, കേന്ദ്രസമിതി അംഗം, സേവനവിഭാഗം കൺവീനർ, ബാലികാവിഭാഗം കൺവീനർ എന്നിവരാണ് ഭാരവാഹികൾ.
  ശങ്കരച്ചേട്ടന്റെ പ്രതിനിധിമാരാണ് മേഖലാ പ്രവർത്തനങ്ങൾക്ക് നേതൃത്വം നൽകുക.
  മലയാള മനോരമയിൽ സേവനം അനുഷ്‌ഠിക്കുന്ന ഇവരെ ശങ്കരച്ചേട്ടൻ നാമനിർദേശം ചെയ്യും.`,
    },
    {
      title: "കേന്ദ്രസമിതി",
      content: `മേഖലകളിലെ പ്രസിഡന്റ്, സെക്രട്ടറി, കേന്ദ്രസമിതി അംഗം എന്നിവർ ഉൾപ്പെട്ടതാണ് കേന്ദ്രസമിതി.
  കേന്ദ്രസമിതിയിൽനിന്നാണ് സംസ്ഥാന ഭാരവാഹികളെ തിരഞ്ഞെടുക്കുക.
  കേന്ദ്രതലത്തിലുള്ള പ്രവർത്തനങ്ങൾക്ക് ശങ്കരച്ചേട്ടൻ മാർഗനിർദേശം നൽകും.`,
    },
    {
      title: "സഖ്യപതാക",
      content: `അഖിലകേരള ബാലജനസഖ്യത്തിന്റെ പതാക മൂന്ന് അടി നീളം രണ്ട് അടി വീതി എന്നീ ക്രമത്തിൽ വലിപ്പമുള്ളതാണ്.
  പതാകയ്‌ക്ക് ചുവപ്പ്, വെള്ള, നീല എന്നീ മൂന്നു നിറങ്ങളുണ്ട്.
  ചുവപ്പ് ഇടതുവശത്തും വെള്ള നടുക്കും നീല വലതുവശത്തും ആയിരിക്കും.
  മധ്യത്തിലുള്ള വെള്ളയിൽ ഉദയസൂര്യന്റെ ചിത്രവും അതിന്റെ കതിരുകളിൽ "സേവനം" എന്ന മുദ്രാവാക്യവും ഉണ്ടായിരിക്കും.`,
    },
  ];
  
  const openPopup = (content) => {
    setSelectedContent(content);
  };

  const closePopup = () => {
    setSelectedContent(null);
  };

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        closePopup();
      }
    };

    if (selectedContent) {
      document.addEventListener("mousedown", handleOutsideClick);
    } else {
      document.removeEventListener("mousedown", handleOutsideClick);
    }

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [selectedContent]);

  return (
    <div className="about-section">
      <h2>അഖില കേരള ബാലജന സഖ്യം</h2>

      <div className="about-grid">
        {sections.map((section, idx) => (
          <div key={idx} className="about-box" onClick={() => openPopup(section.content)}>
            <h3>{section.title}</h3>
          </div>
        ))}
      </div>

      {selectedContent && (
        <div className="aboutpopup-overlay">
          <div className="aboutpopup-content" ref={popupRef}>
            <p>{selectedContent}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default AboutUs;
